// extracted by mini-css-extract-plugin
export default {"slider2":"Obetivo2_slider2__bek1B","slidetrack2":"Obetivo2_slidetrack2__qf5Z9","scroll":"Obetivo2_scroll__K2vPQ","slide2":"Obetivo2_slide2__knydw"};